export const delay = (ms: number): Promise<number> => new Promise((resolve): number => setTimeout(resolve, ms))

export const throttle = (callback: Function, ms: number): void => {
  delay(ms).then(() => callback())
}
